const PROD_DOCS = 'https://otw-docs-prod-m6uviqmkga-uc.a.run.app'

/** @deprecated Staging docs Cloud Run is retired. Portal links use production docs. */
export const STG_DOCS = 'https://otw-docs-stg-ky2zwlng5a-uc.a.run.app'

export function getDocsBaseUrl(): string {
  const override = process.env.VITE_DOCS_PUBLIC_URL?.trim()
  if (override) return override.replace(/\/$/, '')

  // Staging docs selection is deprecated.
  // const projectId = process.env.VITE_FIREBASE_PROJECT_ID
  // if (projectId === 'otw-production-91ffb') return PROD_DOCS
  // return STG_DOCS
  return PROD_DOCS
}

export function getDocsHomeUrl(): string {
  return getDocsBaseUrl()
}

export function getDocsChangelogUrl(): string {
  return `${getDocsBaseUrl()}/business/changelog`
}

export const TICKETS_ORIGIN = 'https://tickets.devrecated.com'

export function ticketsSubmitHref(): string {
  return `${TICKETS_ORIGIN}/?embed=1&view=submit`
}

export function ensureTicketEmbedScript(): void {
  if (typeof document === 'undefined') return
  const sizeId = 'optic-ticket-embed-size'
  let style = document.getElementById(sizeId)
  if (!style) {
    style = document.createElement('style')
    style.id = sizeId
    document.head.appendChild(style)
  }
  style.textContent = `
#autodevelop-embed-root .autodevelop-embed-panel {
  top: 0 !important;
  right: 0 !important;
  bottom: 0 !important;
  left: 0 !important;
  width: auto !important;
  height: auto !important;
  margin: 0 !important;
  transform: none !important;
  box-shadow: none !important;
}
@media (min-width: 720px) {
  #autodevelop-embed-root .autodevelop-embed-panel {
    top: 1rem !important;
    bottom: 1rem !important;
    width: min(80rem, calc(100% - 2rem)) !important;
    margin-inline: auto !important;
    box-shadow: 0 16px 48px rgba(0, 0, 0, 0.2) !important;
  }
}
#autodevelop-embed-root iframe {
  display: block !important;
  flex: 1 1 auto !important;
  width: 100% !important;
  min-width: 0 !important;
  max-width: 100% !important;
  height: 100% !important;
  border: 0 !important;
  transform: none !important;
}
`
  const unscaleEmbedFrame = () => {
    const frame = document.querySelector('#autodevelop-embed-root iframe')
    if (!(frame instanceof HTMLIFrameElement) || frame.dataset.unscaled === '1' || !frame.src) return
    let url: URL
    try {
      url = new URL(frame.src)
    } catch {
      return
    }
    const hadWidthLock = url.searchParams.has('vw')
    frame.dataset.unscaled = '1'
    frame.removeAttribute('width')
    frame.removeAttribute('height')
    if (!hadWidthLock) return
    url.searchParams.delete('vw')
    frame.src = url.toString()
  }
  if (!document.documentElement.dataset.ticketEmbedSharp) {
    document.documentElement.dataset.ticketEmbedSharp = '1'
    const observer = new MutationObserver(() => unscaleEmbedFrame())
    observer.observe(document.documentElement, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['src', 'width', 'height'],
    })
  }
  unscaleEmbedFrame()
  const src = `${TICKETS_ORIGIN}/embed.js?v=4`
  if (document.querySelector('script[src*="/embed.js"]')) return
  const script = document.createElement('script')
  script.src = src
  script.defer = true
  document.body.appendChild(script)
}

if (typeof document !== 'undefined' && document.getElementById('optic-ticket-embed-size')) {
  ensureTicketEmbedScript()
}
